/**
 * Ize Trio: site configuration
 * ----------------------------------------------------------------------------
 * Everything that is likely to change lives here, so the components never have
 * to be edited for routine updates (a new sheet, a new email address, a new
 * social link, and so on).
 */

// ---------------------------------------------------------------------------
// Google APIs
// ---------------------------------------------------------------------------
// The same public, read-only key the old site used. Because it ships inside the
// website code, restrict it in Google Cloud Console (APIs & Services >
// Credentials): limit it to the Sheets API + Calendar API and to the HTTP
// referrers izetrio.com/* and www.izetrio.com/*.
export const GOOGLE_API_KEY = 'AIzaSyB9o13p6a_RHvno6fV9wKSri1Y9rFkSzBA';

// The Google Calendar that feeds the "Live" section.
export const CALENDAR_ID = '557f1qg46s6fehorjr1j13628c@group.calendar.google.com';

// Every Google Sheet the site reads. `range` is what gets fetched.
export const SHEETS = {
  // ONE sheet holds everything on the main page (About, Music, Watch, Band, Support,
  // Contact ...). It is the first tab of the spreadsheet below. See README.md.
  site: { id: '1yxrFli5DUP2vhu-c2ESqiuVT3e9uxJ8NgZsGsOPnJ68', range: 'A1:DZ250' },
  // The stand-alone pages keep their own sheets.
  epk:  { id: '1cv8mvgWj2Be8FDvyoYLjefPl5xkdlYJm66ttuha-Vmc', range: 'A1:F100' },
  fyc:  { id: '1DttO4H7icM4-U2r1bkoqycl_mk5_ORhqT-u1yZ_e5D0', range: 'A1:F100' },
  gpj:  { id: '16xvITGK-hxD72_0QKVxMu2oduAFikRUBTR6Z_SQe-nw', range: 'A1:F100' },
  trio: { id: '1Ex7-NxwryXW445V9YXsXR3O9dNU_-p1VMA9gG7ASTLs', range: 'A1:F100' },
};

// ---------------------------------------------------------------------------
// Fallback site details (the sheet's SITE block overrides these)
// ---------------------------------------------------------------------------
export const SITE = {
  name: 'Ize Trio',
  email: 'izetriomusic@gmail.com',
  // Any of these addresses that appear in sheet text are swapped for `email`.
  oldEmails: ['chasemorrin@gmail.com'],
  // Old text or links that are swapped everywhere they appear in any sheet: [old, new].
  replacements: [['georgelernismusic.com', 'lernismusic.com']],
  instagram: 'https://www.instagram.com/ize_trio/?img_index=1',
  youtube: 'https://youtube.com/playlist?list=PLXKPDoYdvOPADuNsvBbjxTrIakVNYPype&si=dkHDr_Ciab_q1Ywo',
};

// ---------------------------------------------------------------------------
// The one-page layout: order of the sections (menu labels and headings come from the sheet).
// `legacy` are old page URLs (izetrio.com/Bio, /Calendar ...) that now scroll to
// the matching section instead of 404-ing.
// ---------------------------------------------------------------------------
export const SECTIONS = [
  { id: 'about',   label: 'About',   legacy: ['bio'] },
  { id: 'music',   label: 'Music',   legacy: ['recordings'] },
  { id: 'watch',   label: 'Watch' },
  { id: 'live',    label: 'Live',    legacy: ['calendar'] },
  { id: 'band',    label: 'Band' },
  { id: 'support', label: 'Support', legacy: ['donate'] },
  { id: 'contact', label: 'Contact', legacy: ['contact'] },
];

// Pages that are not part of the scrolling page. They keep their old URLs
// (izetrio.com/EPK ...) and render their whole sheet top to bottom.
export const PAGES = {
  epk:  { sheet: 'epk',  title: 'Press kit' },
  fyc:  { sheet: 'fyc',  title: 'For Your Grammy® Consideration', hero: 'fyc' },
  gpj:  { sheet: 'gpj',  title: 'Global Perspectives on Jazz' },
  trio: { sheet: 'trio', title: 'Ize Trio' },
};

// The "For Your Consideration" page opens with the album cover and a band photo. They are
// read from the FYC sheet (the first Image row for the photo, the first Images row for the
// cover); these are used if the sheet has none.
export const FYC_ART = {
  photo: 'img/izetrio/IzeWallSmile.jpg',
  cover: 'img/albums/globalprayer/globalprayercover.jpg',
};

// ---------------------------------------------------------------------------
// Pictures the sheets name that may not exist under that exact name in public/img.
// When the named file is missing, the first listed stand-in that exists is used.
// (Best fix: put a file with the sheet's exact name in public/img.)
// ---------------------------------------------------------------------------
export const IMAGE_ALIASES = {
  'img/izetrio/IzeWallSquareBW.jpg': ['img/izetrio/izewallbw.jpg', 'img/izetrio/IzeBW.jpg'],
  'img/albums/globalprayer/globalprayercover.jpg': ['img/albums/globalprayer/GlobalPrayerDigitalCover.jpg'],
  'img/albums/globalprayer/inside.png': ['img/albums/globalprayer/inside-3.png'],
  'img/albums/globalprayer/outside.png': ['img/albums/globalprayer/outside-4.png'],
};

// ---------------------------------------------------------------------------
// Names that turn into links automatically wherever they appear in sheet text.
// ---------------------------------------------------------------------------
export const LINK_MAP = {
  'Berklee College of Music': 'https://college.berklee.edu/people/chase-morrin',
  'Danilo Pérez': 'http://www.daniloperez.com/',
  'Chase Morrin': 'https://chasemorrin.com/',
  'Naseem Alatrash': 'https://www.alatrashmusic.com/',
  'George Lernis': 'https://lernismusic.com',
  'John Patitucci': 'https://www.johnpatitucci.com/',
  'Farayi Malek': 'https://www.farayimalek.com/',
  'Heiraza': 'https://heiraza.com/',
  'Burcu Gulec': 'https://www.instagram.com/bgulecmusic/?hl=en',
  'Vijay Iyer': 'http://vijay-iyer.com/',
  'Jason Moran': 'http://www.jasonmoran.com/',
};
